<template lang="pug">
UpsertBookingPanel(title="Scheduled products")
  template(v-slot:heading-action="")
    BriqButton(v-if="booking.Key" small @click="addProduct" data-test-id="booking-add-product-button") Add product
  template(v-slot:body="")
    BookingProductsTable(
      :booking="booking"
      :products="products"
      :resources="resources"
      :classifications="classifications"
      @deleteBookingProduct="p => $emit('delete', p)"
      @deleteDeal="key => $emit('deleteDeal', key)"
      )
</template>

<script>
import UpsertBookingPanel from '@v/bookings/edit/components/UpsertBookingPanel.vue'
import BookingProductsTable from './PanelScheduledProducts/BookingProductsTable.vue'

export default {
  name: 'PanelScheduledProducts',
  components: { UpsertBookingPanel, BookingProductsTable },
  props: {
    booking: { type: Object, required: true },
    products: { type: Array, required: true },
    resources: { type: Object, required: true },
    classifications: Array,
  },
  methods: {
    addProduct() {
      this.$setLocationPath(`planboard?legacy&booking=${this.booking.Key}&edit=1`)
    },
  },
}
</script>
